import React from "react";
function AboutSpanish() {
	return (
		<div>
			<p style={{ marginBottom: 10 }}>
				Hola! <span>👋</span> Soy Estefanía, Soy desarrolladora frontend{" "}
				<span>👩🏻‍💻</span> con más de cuatro años de experiencia, especializada en
				HTML, CSS, JavaScript y React.<br/> Me apasiona crear experiencias de usuario
				fluidas y atractivas, enfocándome en la funcionalidad y el diseño de
				interfaces web.
			</p>
			<p style={{ marginBottom: 10 }}>
				Mi formación en Historia del Arte y Gestión Cultural me ha dado una
				perspectiva única para combinar estética y creatividad con la resolución
				de problemas técnicos, algo que encuentro esencial en el desarrollo web.
			</p>
			<p style={{ marginBottom: 10 }}>
				Durante mi carrera he trabajado en proyectos reales que me han permitido
				seguir perfeccionando mis habilidades y aprender de los desafíos del día
				a día.<br/> Mi objetivo es seguir creciendo como profesional y contribuir al
				desarrollo de soluciones web innovadoras.
			</p>
			<p>
				Los proyectos que aparecen en este portfolio corresponden principalmente
				a mis primeras etapas como desarrolladora (2020-2021).<br/> Desde entonces he
				trabajado en proyectos profesionales dentro de equipos de desarrollo,
				cuyo código y desarrollo no son públicos.
			</p>
		</div>
	);
}

export default AboutSpanish;
